import { NgModule } from '@angular/core';
import { AnimationLoader } from '../animation-loader';
import { CacheableAnimationLoader } from './cacheable-animation-loader';
export class LottieCacheModule {
    static forRoot() {
        return {
            ngModule: LottieCacheModule,
            providers: [
                {
                    provide: AnimationLoader,
                    useClass: CacheableAnimationLoader,
                },
            ],
        };
    }
}
LottieCacheModule.decorators = [
    { type: NgModule }
];
//# sourceMappingURL=lottie-cache.module.js.map